module.exports = __webpack_public_path__ + "static/media/pranav.90ffea01.jfif";